import { RefObject, useEffect } from 'react';

export const useEscapeKey = (
   isActive: boolean,
   onEscape: () => void,
   ref: RefObject<HTMLElement | null>,
) => {
   useEffect(() => {
      const node = ref.current;
      if (!isActive || !node) return;

      const handleKeyDown = (event: KeyboardEvent) => {
         if (event.key === 'Escape') {
            event.preventDefault();
            onEscape();
         }
      };

      node.addEventListener('keydown', handleKeyDown);
      return () => node.removeEventListener('keydown', handleKeyDown);
   }, [isActive, onEscape, ref]);
};
